import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { diffVariants, formatCondition } from './agentDiff';
import NodeContentDiff from './NodeContentDiff';

const STATUS_COLOR = { added: 'success', removed: 'error', changed: 'warning' };

export default function SlotVariantDiff({ oldData, newData, viewMode }) {
  const { nameChanged, oldName, newName, variants, fallbackChanged, oldFallback, newFallback } = diffVariants(
    oldData,
    newData
  );
  const noChanges = !nameChanged && variants.length === 0 && !fallbackChanged;

  return (
    <Box>
      {nameChanged && (
        <Typography sx={{ fontSize: 12, mb: 1.5 }}>
          <b>name</b>:{' '}
          <Box component="span" sx={{ color: 'error.main', textDecoration: 'line-through' }}>{oldName}</Box>
          {' → '}
          <Box component="span" sx={{ color: 'success.main' }}>{newName}</Box>
        </Typography>
      )}
      {variants.map((v, i) => (
        <Box key={i} sx={{ mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
            <Chip label={v.status} size="small" color={STATUS_COLOR[v.status]} sx={{ height: 18, fontSize: 10 }} />
            <Typography sx={{ fontFamily: 'monospace', fontSize: 11, color: 'text.secondary' }}>
              if {formatCondition(v.condition)}
            </Typography>
          </Box>
          {v.status === 'changed' ? (
            <NodeContentDiff oldText={v.oldContent} newText={v.newContent} viewMode={viewMode} />
          ) : (
            <Typography component="pre" sx={{ fontSize: 13, whiteSpace: 'pre-wrap', wordBreak: 'break-word', m: 0, fontFamily: 'inherit' }}>
              {v.status === 'added' ? v.newContent : v.oldContent}
            </Typography>
          )}
        </Box>
      ))}
      {fallbackChanged && (
        <Box>
          <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 0.5 }}>fallback</Typography>
          <NodeContentDiff oldText={oldFallback} newText={newFallback} viewMode={viewMode} />
        </Box>
      )}
      {noChanges && <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>No changes.</Typography>}
    </Box>
  );
}
